// Captures UTM / attribution on first landing and preserves it through the
// session until the lead is submitted. Stored in sessionStorage so it survives
// in-app navigation but resets per browsing session.
const KEY = "bonsai_attribution";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export function captureAttribution() {
  try {
    const existing = sessionStorage.getItem(KEY);
    const params = new URLSearchParams(window.location.search);
    const hasUtm = UTM_KEYS.some((k) => params.get(k));

    // Only set once per session, unless a fresh UTM-tagged visit arrives.
    if (existing && !hasUtm) return JSON.parse(existing);

    const attr = existing ? JSON.parse(existing) : {};
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) attr[k] = v;
    });

    if (!attr.landing_page) attr.landing_page = window.location.pathname + window.location.search;
    if (!attr.referrer) attr.referrer = document.referrer || "";

    // Derive a human source if no utm_source
    if (!attr.source) {
      if (attr.utm_source) attr.source = attr.utm_source;
      else if (document.referrer) {
        try {
          const host = new URL(document.referrer).hostname;
          if (host.includes("google")) attr.source = "google";
          else if (host.includes("facebook") || host.includes("instagram")) attr.source = "meta";
          else attr.source = "referral";
        } catch { attr.source = "referral"; }
      } else {
        attr.source = "direct";
      }
    }

    sessionStorage.setItem(KEY, JSON.stringify(attr));
    return attr;
  } catch {
    return {};
  }
}

export function getAttribution() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}
